import React from 'react';
import Utils from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { ReducersModel } from '../../../model';
import { getOperatorReport } from '../action';
import CustomDataTable from '../../../components/customDataTable/customDataTable';
import format from 'date-fns/format';
import { MUIDataTableMeta } from 'mui-datatables';

export default function OperatorReportTable() {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch({
            type: Utils.ActionName.UPDATE_OPERATOR_LIST_REPORT,
            payload: {
                operatorReportData: [],
                page: 1,
                limit: 9999,
            },
        });

        dispatch(getOperatorReport());
    }, [dispatch]);

    const { operatorReportData } = useSelector(
        (state: ReducersModel) => state.operatorReportReducer,
    );

    const headerNames = [
        { name: 'lineNo', label: 'Line No', options: { filter: true, sort: true } },
        { name: 'employeeId', label: 'Employee ID', options: { filter: false, sort: true } },
        { name: 'idNo', label: 'ID No', options: { filter: false, sort: true } },
        { name: 'employeeName', label: 'Employee Name', options: { filter: false, sort: true } },
        {
            name: 'isActive', label: 'Status', options: {
                filter: true, sort: true,
                customBodyRender: (value: any) => {
                    return value ? "Active" : "Inactive";
                }
            }
        },
        {
            name: 'id', label: 'Skill Grade', options: {
                filter: true, sort: true,
                customBodyRender: (dataValue: any, tableMeta: MUIDataTableMeta) => {
                    let value = operatorReportData[tableMeta.rowIndex].assignedSkillGrade ?? operatorReportData[tableMeta.rowIndex].skillGrade;
                    return value;
                }
            }
        },
    ];

    const options = {
        selectableRows: 'none' as const,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 100, 500],
        print: false,
        fixedHeader: true,
        responsive: 'standard' as const,
        tableBodyHeight: '750px',
        downloadOptions: {
            filename: `OperatorReport-${format(new Date(), 'yyyyMMdd')}.csv`,
            separator: ',',
            filterOptions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            }
        },
    };

    return (
        <div>
            <CustomDataTable
                title={"Operator Report"}
                data={operatorReportData}
                columns={headerNames}
                options={options}
            />
        </div>
    );
}
